import { useUser } from "../context/UserContext"
import logo from "../images/logo_white.png"

function Header() {
  const { user } = useUser()

  const displayName = user
    ? user.role === "ADMIN"
      ? "ADMINISTRADOR"
      : user.obraSocial || "OBSERVADOR"
    : ""

  return (
    <div className='header row spacebetween'>
      <div className='headerUsername'>{displayName}</div>
      <img src={logo} alt="logo" />
    </div>
  )
}

export default Header
